import React from 'react'

function ProcessTechDigit() {
    const steps = [
        {
            num: '01',
            title: 'Discovery & Assessment',
            text: 'We start by understanding your actual situation — your systems, your pain points, your industry. No generic proposals. You get real insights from the very first conversation, whether or not you hire us.',
            icon: 'fas fa-search-plus',
        },
        {
            num: '02',
            title: 'Custom Solution Design',
            text: 'We build around your specific needs. The approach is always tailored to your size, workflows, compliance requirements and goals not a package built for someone else.',
            icon: 'fas fa-drafting-compass',
        },
        {
            num: '03',
            title: 'Rapid Implementation',
            text: 'Most clients are fully operational within 2 to 4 weeks. We run alongside your existing processes during transition, so there is no disruption to your day-to-day operations.',
            icon: 'fas fa-rocket',
        },
        {
            num: '04',
            title: 'Ongoing Optimization',
            text: 'Monthly performance reports, proactive communication when something needs attention and continuous refinement based on real data not just at contract renewal.',
            icon: 'fas fa-chart-line',
        },
    ]
    return (
        <div className="process-techdigit td-section  working-process-area home-6 ">
            <div className="container marginbottomm">
                <div className="row ">
                    <div className="col-12">
                        <div className="td-section-head text-center mb-5">
                            <p className="td-section-label">Our Process</p>
                            <h2 className="td-section-title">Simple Steps. Serious Results.</h2>
                            <div className="td-title-rule td-title-rule--center mx-auto" aria-hidden="true" />
                        </div>
                    </div>
                </div>
                <div className="row g-4 g-lg-4">
                    {steps.map((step, i) => (
                        <div key={i} className="col-lg-6 col-md-12">
                            <div className="process-step-card">
                                <div className="process-step-card__header">
                                    <div className="process-step-icon" aria-hidden="true">
                                        <i className={step.icon} />
                                    </div>
                                    <div className="process-step-card__head-text">
                                        <span className="step-num">{step.num}</span>
                                        <h5 className="step-title">{step.title}</h5>
                                    </div>
                                </div>
                                <p className="step-text">{step.text}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default ProcessTechDigit
